@if (notificationSvc.foregroundMessage()) {
  <div class="fixed top-4 right-4 z-[300] max-w-sm rounded-xl bg-midnight-indigo text-white px-4 py-3 shadow-tfr-sm flex items-start gap-3 animate-fade-in">
    <div class="flex-1 min-w-0">
      <p class="text-[13px] font-semibold leading-snug">{{ notificationSvc.foregroundMessage()!.title }}</p>
      <p class="text-[12px] text-steel-gray mt-0.5 leading-snug">{{ notificationSvc.foregroundMessage()!.body }}</p>
    </div>
  </div>
}

<div class="tfr-shell">
  <!-- ── DESKTOP: Fixed Sidebar (lg+) ──────────────────────────────── -->
  <aside
    class="tfr-sidebar hidden lg:flex w-[280px] shrink-0 flex-col fixed top-[calc(4rem+var(--tfr-banner-offset,0px))] left-0 bottom-0 z-30"
  >
    <!-- Nav items: Desktop Sidebar -->
    <nav class="flex-1 px-3 py-5 pt-6 space-y-4 overflow-y-auto">
      @if (isAdmin()) {
        <div>
          <p [class]="sidebarBlockTitleClass + ' tfr-sidebar-section-label'">
            Administraci&oacute;n
          </p>
          <button
            type="button"
            (click)="goAdminDashboard()"
            class="tfr-sidebar-link"
            [class.tfr-sidebar-link--active]="isAdminDashboardActive()"
            [class.tfr-sidebar-link--idle]="!isAdminDashboardActive()"
          >
            <lucide-icon name="layout-dashboard" class="h-[18px] w-[18px] shrink-0" />
            Panel admin
          </button>
          <button
            type="button"
            (click)="goAdminCrm()"
            class="tfr-sidebar-link"
            [class.tfr-sidebar-link--active]="isAdminCrmActive()"
            [class.tfr-sidebar-link--idle]="!isAdminCrmActive()"
          >
            <lucide-icon name="users" class="h-[18px] w-[18px] shrink-0" />
            CRM prospecci&oacute;n
          </button>
          <button
            type="button"
            (click)="goAdminUsers()"
            class="tfr-sidebar-link"
            [class.tfr-sidebar-link--active]="isAdminUsersActive()"
            [class.tfr-sidebar-link--idle]="!isAdminUsersActive()"
          >
            <lucide-icon name="user-cog" class="h-[18px] w-[18px] shrink-0" />
            Usuarios
          </button>
        </div>
      }

      @if (isOwner()) {
        <div>
          <p [class]="sidebarBlockTitleClass + ' tfr-sidebar-section-label'">
            Gesti&oacute;n
          </p>
          <button
            type="button"
            (click)="navigateTo('panel')"
            class="tfr-sidebar-link"
            [class.tfr-sidebar-link--active]="isActive('panel')"
            [class.tfr-sidebar-link--idle]="!isActive('panel')"
          >
            <lucide-icon
              name="layout-dashboard"
              class="h-[18px] w-[18px] shrink-0"
            />
            Panel de Control
          </button>
          <button
            type="button"
            (click)="navigateTo('mis-espacios')"
            class="tfr-sidebar-link"
            [class.tfr-sidebar-link--active]="isActive('mis-espacios')"
            [class.tfr-sidebar-link--idle]="!isActive('mis-espacios')"
          >
            <lucide-icon name="building-2" class="h-[18px] w-[18px] shrink-0" />
            Mis Espacios
          </button>
          <button
            type="button"
            (click)="navigateTo('alquileres')"
            class="tfr-sidebar-link"
            [class.tfr-sidebar-link--active]="isActive('alquileres')"
            [class.tfr-sidebar-link--idle]="!isActive('alquileres')"
          >
            <lucide-icon
              name="calendar-check-2"
              class="h-[18px] w-[18px] shrink-0"
            />
            Reservas recibidas
          </button>
          <button
            type="button"
            (click)="navigateTo('facturas')"
            class="tfr-sidebar-link"
            [class.tfr-sidebar-link--active]="isActive('facturas')"
            [class.tfr-sidebar-link--idle]="!isActive('facturas')"
          >
            <lucide-icon name="file-text" class="h-[18px] w-[18px] shrink-0" />
            Facturas
          </button>
        </div>
      }
      <div>
        <p [class]="sidebarBlockTitleClass + ' tfr-sidebar-section-label'">
          Personal
        </p>
        <button
          type="button"
          (click)="goExplore()"
          class="tfr-sidebar-link"
          [class.tfr-sidebar-link--active]="isExploreActive()"
          [class.tfr-sidebar-link--idle]="!isExploreActive()"
        >
          <lucide-icon name="search" class="h-[18px] w-[18px] shrink-0" />
          Explorar espacios
        </button>
        <button
          type="button"
          (click)="navigateTo('mis-reservas')"
          class="tfr-sidebar-link"
          [class.tfr-sidebar-link--active]="isActive('mis-reservas')"
          [class.tfr-sidebar-link--idle]="!isActive('mis-reservas')"
        >
          <lucide-icon name="ticket" class="h-[18px] w-[18px] shrink-0" />
          Mis Reservas
        </button>
        <button
          type="button"
          (click)="navigateTo('ajustes')"
          class="tfr-sidebar-link"
          [class.tfr-sidebar-link--active]="isActive('ajustes')"
          [class.tfr-sidebar-link--idle]="!isActive('ajustes')"
        >
          <lucide-icon name="settings" class="h-[18px] w-[18px] shrink-0" />
          Ajustes
        </button>
      </div>
    </nav>

    <div class="px-3 pb-6 tfr-sidebar-divider--top">
      <button type="button" (click)="logout()" class="tfr-sidebar-logout">
        <lucide-icon name="log-out" class="h-4 w-4 shrink-0" />
        Cerrar sesi&oacute;n
      </button>
    </div>
  </aside>

  <!-- ── MAIN: Content Area ──────────────────────────────────────────── -->
  <div class="flex-1 lg:ml-[280px] flex flex-col min-h-[calc(100vh-4rem-var(--tfr-banner-offset,0px))] pb-20 lg:pb-0 min-w-0 w-full bg-cloud-mist">
    <div class="flex-1 flex flex-col min-w-0 w-full">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- ── MOBILE: Bottom Navigation Bar (< lg) ─────────────────────── -->
  <nav class="tfr-mobile-nav">
    @if (isOwner()) {
      <div class="flex items-stretch justify-around">
        <button
          type="button"
          (click)="navigateTo('panel')"
          class="tfr-tab-btn"
          [class.tfr-tab-btn--active]="isActive('panel')"
          [class.tfr-tab-btn--inactive]="!isActive('panel')"
          aria-label="Panel de control"
        >
          <lucide-icon name="layout-dashboard" [size]="18" />
          <span class="text-[10px] font-medium tracking-tight leading-none"
            >Panel</span
          >
        </button>

        <button
          type="button"
          (click)="navigateTo('mis-espacios')"
          class="tfr-tab-btn"
          [class.tfr-tab-btn--active]="isActive('mis-espacios')"
          [class.tfr-tab-btn--inactive]="!isActive('mis-espacios')"
          aria-label="Mis espacios"
        >
          <lucide-icon name="building-2" [size]="18" />
          <span class="text-[10px] font-medium tracking-tight leading-none"
            >Espacios</span
          >
        </button>

        <button
          type="button"
          (click)="navigateTo('alquileres')"
          class="tfr-tab-btn"
          [class.tfr-tab-btn--active]="isActive('alquileres')"
          [class.tfr-tab-btn--inactive]="!isActive('alquileres')"
          aria-label="Reservas recibidas"
        >
          <lucide-icon name="calendar-check-2" [size]="18" />
          <span class="text-[10px] font-medium tracking-tight leading-none"
            >Recibidas</span
          >
        </button>

        <button
          type="button"
          (click)="navigateTo('mis-reservas')"
          class="tfr-tab-btn"
          [class.tfr-tab-btn--active]="isActive('mis-reservas')"
          [class.tfr-tab-btn--inactive]="!isActive('mis-reservas')"
          aria-label="Mis reservas"
        >
          <lucide-icon name="ticket" [size]="18" />
          <span class="text-[10px] font-medium tracking-tight leading-none"
            >Reservas</span
          >
        </button>

        <button
          type="button"
          (click)="navigateTo('ajustes')"
          class="tfr-tab-btn"
          [class.tfr-tab-btn--active]="isActive('ajustes')"
          [class.tfr-tab-btn--inactive]="!isActive('ajustes')"
          aria-label="Ajustes"
        >
          <lucide-icon name="settings" [size]="18" />
          <span class="text-[10px] font-medium tracking-tight leading-none"
            >Ajustes</span
          >
        </button>
      </div>
    }

    @if (!isOwner()) {
      <div class="flex items-stretch justify-around">
        <button
          type="button"
          (click)="goExplore()"
          class="tfr-tab-btn tfr-tab-btn--inactive"
          aria-label="Explorar espacios"
        >
          <lucide-icon name="search" [size]="18" />
          <span class="text-[10px] font-medium tracking-tight leading-none"
            >Explorar</span
          >
        </button>

        <button
          type="button"
          (click)="navigateTo('mis-reservas')"
          class="tfr-tab-btn"
          [class.tfr-tab-btn--active]="isActive('mis-reservas')"
          [class.tfr-tab-btn--inactive]="!isActive('mis-reservas')"
          aria-label="Mis reservas"
        >
          <lucide-icon name="ticket" [size]="18" />
          <span class="text-[10px] font-medium tracking-tight leading-none"
            >Reservas</span
          >
        </button>

        <button
          type="button"
          (click)="navigateTo('ajustes')"
          class="tfr-tab-btn"
          [class.tfr-tab-btn--active]="isActive('ajustes')"
          [class.tfr-tab-btn--inactive]="!isActive('ajustes')"
          aria-label="Ajustes"
        >
          <lucide-icon name="settings" [size]="18" />
          <span class="text-[10px] font-medium tracking-tight leading-none"
            >Ajustes</span
          >
        </button>
      </div>
    }
  </nav>
</div>
